// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'noticeCount') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setNoticeCount', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}

// 路由拦截器
router.beforeEach((to, from, next) => {
    // next();
    // return
    if (to.matched.length != 0) {
        let token = localStorage.getItem('userToken')
        let sign = localStorage.getItem('sign')
        let userPath = ['/customer/applyEval','/customer/evalRecord','/customer/applyDrafts','/customer/personCenter']
        let agentPath = ['/agent/waitEval','/agent/writeEval','/agent/agentEvalRecord','/agent/agentPersonCenter']
        let adminPath = ['/system/account','/system/case','/system/personCenter','/system/platformChart']
        let path = to.path
        if (to.meta.requireAuth) { 
            // 判断该路由是否需要登录权限
            // 通过vuex state获取当前的user是否存在
            if (token && sign) { 
                if(sign == 'user'){
                    if(userPath.includes(path)){
                        next();
                    }else{
                        next({
                            path: '/index',
                            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                        })
                    }
                }
                if(sign == 'agent'){
                    if(agentPath.includes(path)){
                        next();
                    }else{
                        next({
                            path: '/index',
                            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                        })
                    }
                }
                if(sign == 'admin'){
                    if(adminPath.includes(path)){
                        next();
                    }else{
                        next({
                            path: '/index',
                            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                        })
                    }
                }
            } else {
                // 将跳转的路由path作为参数，登录成功后跳转到该路由
                next({
                    path: '/index',
                    query: { redirect: to.fullPath } 
                })
            }
        } else {
            // 判断是否登录
            if (token && sign) { 
                //判断是否要跳到登录界面
                if (to.path != "/" && to.path != "/index") { 
                    if(sign == 'user'){
                        if(userPath.includes(path)){
                            next();
                        }else{
                            next({
                                path: '/index',
                                query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            })
                        }
                    }
                    if(sign == 'agent'){
                        if(agentPath.includes(path)){
                            next();
                        }else{
                            next({
                                path: '/index',
                                query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            })
                        }
                    }
                    if(sign == 'admin'){
                        if(adminPath.includes(path)){
                            next();
                        }else{
                            next({
                                path: '/index',
                                query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            })
                        }
                    }
                   
                } else {
                    /**
                     * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页 
                     */
                    if(sign =='user'){
                        next({
                            path: '/customer/applyEval'
                        })
                    }
                    if(sign == 'agent'){
                        next({
                            path: '/agent/writeEval'
                        })
                    }
                    if(sign == 'admin'){
                        next({
                            path: '/system/account'
                        })
                    }
                }
            } else {
                next();
            }
        }
    } else {
        next({
            path: '/index',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})

//我这里设置的是2000毫秒也就是2秒 按钮点击后2s不能再点
Vue.directive('noMoreClick', {
  inserted(el, binding) {
    el.addEventListener('click', e => {
      el.classList.add('is-disabled')
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
        el.classList.remove('is-disabled')
      }, 2000)
    })
  }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})


// WEBPACK FOOTER //
// ./src/main.js